<template>
  <AccountSubscriptionForm
    :default-data="{}"
    :agency-options="agencyOptions"
    :billing-period-options="billingPeriodOptions"
    :membership-product-options="membershipProductOptions"
    :server-errors="serverErrors"
    :disabled="isLoading"
    @account-subscription-form:submit="doStore"
    @account-subscription-form:cancel="doCancel"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import AccountSubscriptionFormVue from './AccountSubscriptionForm.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  name: 'CreateAccountAccountSubscriptionForm',

  components: {
    AccountSubscriptionForm: AccountSubscriptionFormVue,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
    agencyOptions: {
      type: Array,
      default: () => [],
    },
    billingPeriodOptions: {
      type: Array,
      default: () => [],
    },
    membershipProductOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      status: STATUS_IDLE,
      serverErrors: {},
      errorMessage: '',
    };
  },

  computed: {
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  methods: {
    ...mapActions('ui/accountAccountSubscriptions', {
      storeAccountAccountSubscription: 'store',
    }),

    async doStore(formData) {
      if (this.isLoading) return;

      const { accountId } = this;

      this.errorMessage = '';
      this.status = STATUS_PENDING;

      try {
        const { accountSubscriptionUuid } = await this.storeAccountAccountSubscription({
          accountId,
          formData,
        });

        this.status = STATUS_RESOLVED;

        this.$emit('create-account-subscription-form:created', accountSubscriptionUuid);
      } catch (error) {
        this.status = STATUS_REJECTED;

        if (!error.response) {
          this.errorMessage = 'Something went wrong. Try again later';
        }

        if (error.response.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.data.errors = error.response.data.errors;
          this.data.errorMessage = error.response.data.message;
        }
      }
    },

    doCancel() {
      if (this.isLoading) return;

      this.$emit('create-account-subscription-form:cancel');
    },
  },
};
</script>
